<style lang="scss" scoped>
.text-link {
    font-size: 1rem;
    font-weight: 300;
    color: #fff !important;
    text-decoration: none !important;

    span {
        margin-left: 8px;

        ::v-deep .arrow-right-svg {
            transition: transform 0.15s;
        }
    }

    &:hover {
        ::v-deep .arrow-right-svg {
            transform: translateX(8px);
        }
    }
}

.image-container {
    overflow: hidden;

    img {
        transition: transform 0.15s;
    }
}

.bg-container {
    width: 100%;
    position: absolute;
    left: 0;

    @media (min-width: 1024px) {
        position: relative;
    }
}

.bg-accent {
    height: 100%;

    @media (min-width: 1024px) {
        height: auto;
    }
}

.floating-category-card {
    position: relative;
    width: 50%;
    height: 100%;
    transition: margin 0.15s ease-in-out, border-radius 0.15s ease-in-out,
        box-shadow 0.15s ease-in-out;

    @media (min-width: 768px) {
        width: calc(100% / 3);
    }

    @media (min-width: 1280px) {
        width: 25%;
    }

    @media (min-width: 1921px) {
        width: 20%;
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        font-family: "object-fit: cover;";
        position: relative;
        z-index: 2;
        transition: border-radius 0.15;
    }

    .zoom-wrapper {
        width: 100%;
        height: 100%;
        position: absolute;
        overflow: hidden;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        transition: height 0.15s ease-in-out, width 0.15s ease-in-out,
            box-shadow 0.15s;
    }

    .content {
        position: absolute;
        z-index: 3;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        padding: 24px;        
        line-height: 1.2;
        transform: translateY(80px);
        transition: transform 0.15s 0.15s ease-in-out;

        .subtitle {
            font-size: 1rem;
        }

        .more {
            opacity: 0;
            transition: opacity 0.15s 0.15s;
        }
    }

    &.descending {
        z-index: 3;

        .content {
            transition-delay: 0;
        }
    }

    &.floating {
        z-index: 3;
        border-radius: 4px;
        border-radius: 4px;

        .zoom-wrapper {
            width: calc(100% * 1.15);
            height: calc(100% * 1.15);
            box-shadow: 0 0 20px -5px rgba(0, 0, 0, 0.4);
        }

        .image-container {
            border-radius: 4px;

            img {
                transform: scale(1.1);
            }

            .content {
                transform: none;

                .more {
                    opacity: 1;
                }
            }
        }
    }
}

.floating-container {
    position: absolute;
    width: calc(100vw - (100vw - 100%) / 2);
    left: 0;
    top: 0;
    border-radius: 4px 0 0 0;
    padding: inherit;

    @media (min-width: 1024px) {
        background-color: #fff;
    }

    &[data-card-count=""],
    &[data-card-count="1"],
    &[data-card-count="2"],
    &[data-card-count="3"] {
        width: 100%;

        @media screen and (min-width: 1024px) {
            padding-right: 40px;
            border-radius: 4px 4px 0 0;
        }

        @media screen and (min-width: 1280px) {
            padding-right: 80px;
        }
    }

    &[data-card-count="1"] {
        .floating-category-card {
            width: 100% !important;

            .content {
                left: 55%;
            }

            &.floating {
                .zoom-wrapper {
                    width: calc(100% * 1.05);
                    height: calc(100% * 1.05);
                }
            }
        }
    }
    &[data-card-count="2"] {
        .floating-category-card {
            width: 50% !important;

            .content {
                left: 60%;
            }

            &.floating {
                .zoom-wrapper {
                    width: calc(100% * 1.1);
                    height: calc(100% * 1.1);
                }
            }
        }
    }
    &[data-card-count="3"] {
        .floating-category-card {
            width: calc(100% / 3) !important;
        }
    }
}
</style>

<template>
    <div class="story-row">
        <div class="bg-accent pt-40 pt-md-80 pt-xxl-120" ref="accentcontainer">
            <div class="container">
                <div class="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center mb-40 mb-md-80" ref="titlecontainer">
                    <h2 class="text-white mb-16 mb-lg-0">{{ title }}</h2>
                    <a class="text-link" :href="href">{{ btn }} <span class="arrow-right" v-html="svg('arrow-right', 'arrow-right-svg')" /></a>
                </div>

                <div ref="roundedcontainer" class="bg-container rounded pt-lg-40 pl-lg-40 pt-xl-80 pl-xl-80">
                    <div ref="floatingcontainer" class="floating-container d-flex" :data-card-count="stories.length">
                        <div class="floating-category-card flex-shrink-0" v-for="(story,index) in stories" :key="story.slug" @mouseenter="floatElement" @mouseleave="unfloatElement">
                            <div class="zoom-wrapper">
                                <a :href="route('nl.story', {'slug' : story.post_name})" class="d-inline-block w-100 h-100">
                                    <div class="image-container h-100 d-flex" :ref="`imagecontainer${index}`">
                                        <img :src="story.acf.image.sizes.large" :alt="story.post_title">

                                        <div class="content d-flex flex-column justify-content-end" :style="`max-width: ${contentWidth}px`" >
                                            <span class="subtitle mb-8 text-white font-weight-light">{{ story.acf.author }}</span>
                                            <span class="title text-white font-weight-bold d-block">{{ story.post_title }}</span>
                                            <span class="more small font-weight-light text-white mt-64">Lees meer</span>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import floatingElements from "../mixins/floating-elements";

export default {
    name: "pageParts.story-row",

    mixins: [floatingElements],

    props: {
        title: {
            type: String,
            required: true,
            default: ''
        },
        stories: {
            type: Array,
            required: true,
            default: () => {
                return [];
            },
        },
        btn: {
            type: String,
            required: true,
            default: '',
        },
        href: {
            type: String,
            required: true,
            default: '',
        },
        ratio: {
            type: [String, Boolean],
            default: '310:440',
            required: false
        }
    },

    data: (vm) => ({
        oldWidth: document.documentElement.clientWidth,
        contentWidthInPx: 1000
    }),

    mounted() {
        var self = this;

        self.calculateElementHeight();
        self.calculateContentWidth();
        self.calculateMinimumWrapperHeight();

        window.addEventListener('resize', () => { // only on width change because URL bar resizing on mobile         
            var newWidth = document.documentElement.clientWidth;
            if (newWidth != self.oldWidth) {
                self.calculateElementHeight();
                self.calculateContentWidth();
                self.calculateMinimumWrapperHeight();
            }
            self.oldWidth = newWidth;
        });

        window.addEventListener('orientationchange', () => {
            self.calculateElementHeight();
            self.calculateContentWidth();
            self.calculateMinimumWrapperHeight();
        });
    },

    methods: {
        arWidth() {
            if (!this.ratio) return 0
            return this.ratio.split(':')[0]
        },

        arHeight() {
            if (!this.ratio) return 0
            return this.ratio.split(':')[1]
        },

        vw() {
            return document.documentElement.clientWidth;
        },

        calculateMinimumWrapperHeight() {
            var titleWrapperHeight = this.$refs.titlecontainer.clientHeight;
            var floatingcontainerHeight = this.$refs.floatingcontainer.clientHeight;

            if (this.vw() >= 1024) {
                this.$refs.accentcontainer.style.minHeight = 0;
            } else if (this.vw() >= 768) {
                this.$refs.accentcontainer.style.minHeight = (titleWrapperHeight + floatingcontainerHeight) + 160 + "px";
            } else {
                this.$refs.accentcontainer.style.minHeight = (titleWrapperHeight + floatingcontainerHeight) + 80 + "px";
            }
        },

        calculateElementHeight() {
            var elementsAmount = 5;
            var vw = this.vw();

            var floatingContainer = this.$refs.floatingcontainer;
            var roundedContainer = this.$refs.roundedcontainer;

            //element amounts according to element widths in css
            if (vw > 1920) {
                elementsAmount = 5;
            } else if (vw >= 1280) {
                elementsAmount = 4;
            } else if (vw >= 768) {
                elementsAmount = 3;
            } else {
                elementsAmount = 2;
            }

            var padding = parseInt(window.getComputedStyle(roundedContainer, null).getPropertyValue('padding-left'), 10);

            var containerwidth = floatingContainer.clientWidth - padding;
            var ratio = (this.arWidth() / this.arHeight());

            var calculatedHeight = (containerwidth / elementsAmount) / ratio + padding;

            roundedContainer.style.height = calculatedHeight + "px";
            floatingContainer.style.height = calculatedHeight + "px";
        },

        calculateContentWidth() {
            this.contentWidthInPx = this.$refs.imagecontainer0[0].clientWidth - 48;
        }
    },

    computed: {
        contentWidth() {
            return this.contentWidthInPx;
        }
    }
}
</script>